const calculateDesnivelAcumulado = (records = []) => {
  if (!Array.isArray(records) || records.length < 2) {
    console.warn("? No hay suficientes records para analizar altitud.");
    return 0;
  }

  const altitudes = records
    .map(r => r.enhanced_altitude)
    .filter(e => typeof e === 'number' && !isNaN(e));

  if (altitudes.length < 2) {
    console.warn("? No hay suficientes datos de altitud v�lidos en records.");
    return 0;
  }

  let desnivelPositivo = 0;
  for (let i = 1; i < altitudes.length; i++) {
    if (altitudes[i] > altitudes[i - 1]) {
      desnivelPositivo += altitudes[i] - altitudes[i - 1];
    }
  }

  console.log("?? Altitudes v�lidas:", altitudes.slice(0, 10));
  console.log("?? Desnivel positivo acumulado calculado:", desnivelPositivo, "m");

  return Math.round(desnivelPositivo);
};

export default calculateDesnivelAcumulado;
